module.exports = __webpack_public_path__ + "static/img/2.98dee8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/2.png
// module id = 2K3n
// module chunks = 0